import { useEffect, useState } from "react";
import { getLocations } from "../lib/api";

function to12h(t) {
  if (!t) return null;
  const [h, m] = String(t).split(":");
  const hour = Number(h);
  const suffix = hour >= 12 ? "PM" : "AM";
  const display = hour % 12 === 0 ? 12 : hour % 12;
  return `${display}:${m} ${suffix}`;
}

/** Operating hours always come from the BFF so the site and the booking
 *  engine can never disagree. No hardcoded marketing hours. */
export const useHours = () => {
  const [locations, setLocations] = useState(null);

  useEffect(() => {
    let alive = true;
    getLocations()
      .then((d) => alive && setLocations(d.locations))
      .catch(() => alive && setLocations([]));
    return () => {
      alive = false;
    };
  }, []);

  const hoursFor = (slug) => {
    const loc = (locations || []).find((l) => l.slug === slug);
    if (!loc || !loc.openTime || !loc.closeTime) return null;
    return {
      open: to12h(loc.openTime),
      close: to12h(loc.closeTime),
      source: loc.hoursSource,
      raw: loc,
    };
  };

  return { locations, hoursFor, loading: locations === null };
};

export default useHours;
